import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled
} from '@mui/material';
import { dateFormatter, getReccurssiveObjectKeys } from '../../../../../utils';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(0.9),
  whiteSpace: 'nowrap',
  fontSize: '15px',
  fontWeight: 500
}));

export const BloodRequestStatusTable = ({
  data,
  columns,
  onRowClick,
  containerSX,
  sx,
  size,
  showStatuses,
  handleStatusCrossMatchChange,
  handleStatusDonorChange,
  handleStatusCancelChange,
  handleStatusIssueChange,
  selectedRadio
}) => {
  return (
    <TableContainer sx={{ maxHeight: '250px', ...containerSX }}>
      <MuiTable sx={sx} size={size || 'medium'}>
        <TableHead>
          <TableRow sx={{ backgroundColor: 'lightblue' }}>
            <StyledTableCell key="sr.no.-cell" sx={{ fontWeight: 'bold' }}>
              Sr. No.
            </StyledTableCell>
            {columns.map((column, index) => (
              <StyledTableCell sx={{ fontWeight: 'bold' }} key={`header-cell-${index}`}>
                {column.header}
              </StyledTableCell>
            ))}
            {showStatuses && (
              <StyledTableCell key="statuses-cell" sx={{ fontWeight: 'bold' }}>
                Actions
              </StyledTableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow
              {...(onRowClick && {
                onClick: () => {
                  onRowClick(row);
                }
              })}
              sx={{
                backgroundColor: rowIndex % 2 ? 'grey.200' : 'none',
                cursor: onRowClick ? 'pointer' : 'default',
                '&:hover': {
                  backgroundColor: 'grey.300'
                },
                transition: 'all 0.1s ease-in'
              }}
              key={row._id}
            >
              <StyledTableCell key={`${row._id}-cell0`}>{rowIndex + 1}</StyledTableCell>
              {columns.map(({ header, accessor, sx }, colIndex) => (
                <StyledTableCell sx={sx} key={`${row._id}-cell${colIndex + 1}`}>
                  {typeof accessor === 'function' ? (
                    accessor(row) || '-'
                  ) : (
                    <>
                      {header === 'Created At' || header === 'Date'
                        ? dateFormatter(getReccurssiveObjectKeys(row, accessor)) || '-'
                        : getReccurssiveObjectKeys(row, accessor) || '-'}
                    </>
                  )}
                </StyledTableCell>
              ))}
              {showStatuses && (
                <StyledTableCell key={`${row._id}-cell-statuses`} sx={{ marginRight: 1 }}>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {selectedRadio !== "crossmatch" &&(<Button
                      onClick={() => handleStatusCrossMatchChange(row, 'deferred')}
                      variant="contained"
                      sx={{ fontSize: 8, color: 'white' }}
                    >
                      Cross Match
                    </Button>)}
                    {selectedRadio !== "cancelled" &&(<Button
                      onClick={() => handleStatusCancelChange(row, 'cancel')}
                      variant="contained"
                      sx={{ fontSize: 8, color: 'white' }}
                    >
                      Cancel
                    </Button>)}
                    {selectedRadio !=="donor" &&(<Button
                      onClick={() => handleStatusDonorChange(row, 'done')}
                      variant="contained"
                      sx={{ fontSize: 8, color: 'white' }}
                    >
                      Donor
                    </Button>)}
                    {selectedRadio !=="issue" &&(<Button
                      onClick={() => handleStatusIssueChange(row, 'done')}
                      variant="contained"
                      sx={{ fontSize: 8, color: 'white' }}
                    >
                      Issue
                    </Button>)}
                  </Box>
                </StyledTableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};
